import { Navigate } from "react-router-dom";
import { routes } from "../../routes";
import { useAuth } from "../Authorization";
import { Loaders, QueryRenderer } from "../QM/QueryRenderer";
import { useSessionsQuery } from "./Sessions";

export const WithIsFirstSession = ({
  loaderEl = <Loaders.CircularBlock spaced />,
  // TODO: errored Layout
  children,
}) => {
  const { user } = useAuth();
  const isFirstSession = !user.data.areaOfDevelopment?.length;
  const sessionsQuery = useSessionsQuery({ enabled: !isFirstSession });

  if (isFirstSession) return children({ isFirstSession });

  return (
    <QueryRenderer
      query={sessionsQuery}
      loaderEl={loaderEl}
      success={({ data }) => {
        const lastSessionIdMaybe = data?.[0]?.id;
        if (!lastSessionIdMaybe) return children({ isFirstSession: true });
        else
          return children({
            isFirstSession: false,
            lastSessionId: lastSessionIdMaybe,
          });
      }}
    />
  );
};

export function StartSessionPage() {
  return <Navigate to={routes.session} replace />;
}
